import { userGitCredsQuery } from '@common/git/GitIntegration/queries';
import { graphql } from '@prophecy/graphql-types/graphql';
import { ExtractArrayType } from '@prophecy/interfaces/generic';
import { ResultOf } from 'gql.tada';

import { getUserFabricFields } from '../data/apis/getUserFabricFields';

export function getUserQuery(isSqlProject: boolean, hasAirflow: boolean) {
  return graphql(`
    query UserFabricQuery($id: String!) {
      User(uid: $id) {
        _id
        attributes
        firstName
        lastName
        company
        created
        email
        copilotEnabled
        teams {
          _id
          name
        }
        gitSavedCreds {
          ${userGitCredsQuery}
        }
        aspects(aspect: [Info]) {
          AspectName
          AspectValue
        }
        fabrics {
          ${getUserFabricFields(isSqlProject, hasAirflow)}
        }
        SqlFabricCredsInfoAspect: aspects(aspect: SqlFabricCredsInfo) {
          AspectValue
          AspectName
        }
      }
    }
  `);
}

export const teamGitCredsQuery = graphql(`
  query TeamGitCredsQuery($teamUID: String) {
    TeamGitCreds(teamUID: $teamUID) {
      
        ${userGitCredsQuery}
      
    }
  }
`);

export type UserQueryResponse = ResultOf<ReturnType<typeof getUserQuery>>;
export type User = NonNullable<NonNullable<UserQueryResponse>['User']>;
export type UserFabric = ExtractArrayType<User['fabrics']>;

export const checkEmailIdExists = graphql(`
  query checkEmailIdExists($emailIDs: [String!]!) {
    ifEmailExists(emailIds: $emailIDs) {
      email
      exists
    }
  }
`);
